export default "__VITE_ASSET__LR7TQWb6vVWFYAGb7_hp7g__"